import React, { useState } from "react";
import { Box } from "@mui/material";
import styles from "./settingsPage.module.scss";
import Button from "../../components/buttons/Buttons";
import EmailTemplate from "./EmailTemplate/EmailTemplate";
import i18next from "i18next";
import CustomSnackbar from "../../components/customSnackBar/CustomSnackbar";
import CeritificateTemplate from "./CertificateTemplate/CertificateTemplate";

const SettingsPage = () => {
  const [cerificateTemplate, setCerificateTemplate] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const snackBarMessage = "Content Saved Successfully";
  return (
    <>
      <Box className={styles.textSettings} data-testid="SettingsPage">
        {i18next.t("Settings")}
      </Box>
      <Box className={styles.settingWrapper}>
        <Box className={styles.leftButtonWrapper}>
          <Button
            title="Email Templates"
            iconStyle={styles.mail}
            classList={emailTemplate ? styles.sample : styles.buttonStyle}
            withIcon={true}
            attriType={"button"}
            handleClick={() => {
              setEmailTemplate(true);
              setCerificateTemplate(false);
            }}
            isDisabled={false}
          />

          <Button
            title="Certificate Template"
            iconStyle={styles.preview}
            classList={cerificateTemplate ? styles.sample : styles.buttonStyle}
            withIcon={true}
            attriType={"button"}
            isDisabled={false}
            handleClick={() => {
              setEmailTemplate(false);
              setCerificateTemplate(true);
            }}
          />
        </Box>
        <Box className={styles.rightContentWrapper}>
          {emailTemplate ? (
            <EmailTemplate setOpenSnackbar={setOpenSnackbar} />
          ) : null}
          {cerificateTemplate ? (
            <CeritificateTemplate setOpenSnackbar={setOpenSnackbar} />
          ) : null}
        </Box>
        {openSnackbar && (
          <CustomSnackbar
            open={openSnackbar}
            message={snackBarMessage}
            setOpen={setOpenSnackbar}
          />
        )}
      </Box>
    </>
  );
};

export default SettingsPage;
